import React from "react";
import { Form, Popover, theme, Tooltip, Select, Flex, message } from "antd";
import { URL_CHEMICAL} from "../../constants/urls";
import { POST } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";
import { EditOutlined } from "@ant-design/icons";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";


export default function QualityChemicalChangeTankPopover({
  target=null,
  onUpdate=() => null,
}){
  const { token: { colorWarning } } = theme.useToken();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm(); 
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const tankDropdown = useDropdownItem({
    url: URL_CHEMICAL.QUALITY_CHEMICAL_TANK,
    manual: true, pagination: true,
    params: { page_size: 999 },
  })

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      await POST(URL_CHEMICAL.CHANGE_QUALITY_TANK_LOG, values)
      onUpdate();
      setVisible(false); 
    } catch (error) {
      messageApi.error({ content: error.errorMessages })
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (visible) {
      tankDropdown.fetchOptions();
      form.resetFields();
    }
  }, [visible])

  return (
    <span>
      {contextHolder}
      <Popover
        title={<center>เปลี่ยนแทงก์สารเคมี</center>}
        trigger='click'
        open={visible}
        onOpenChange={setVisible}
        content={
          <Form form={form} autoComplete="off" onFinish={handleSubmit} layout={"vertical"}>
            <Form.Item hidden name='transaction' initialValue={target} />
            <Form.Item
              name='destination'
              label='แทงก์ปลายทาง'
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]} 
            >
              <Select
                showSearch
                style={{ width: 250 }}
                options={tankDropdown.options}
                placeholder={'แทงก์ปลายทาง'}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item>
              <Flex gap='small' justify='flex-end'>
                <ColorButton htmlType='button' loading={loading}>ปิด</ColorButton>
                <ColorButton type='primary' override={colorWarning} htmlType='submit' loading={loading}>แก้ไข</ColorButton>
              </Flex>
            </Form.Item>
          </Form>
        }
      >
        <Tooltip trigger='hover' title='เปลี่ยนแทงก์สารเคมี'>
          <ColorButton
            size='small'
            override={colorWarning}
            color='primary'
            variant='text'
            icon={<EditOutlined style={{ color: colorWarning }}/>}/>
        </Tooltip>
      </Popover> 
    </span>
  )
}